export { default } from './QuickFacts';
